import React from 'react';
import { handleFieldArrowNavigation } from '../../utils/fieldArrowNavigation';

export default function Modal({ title, onClose, children, width = 680, className = '' }) {
  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div
        className={['modal', className].filter(Boolean).join(' ')}
        style={{ width }}
        onKeyDown={(e) => handleFieldArrowNavigation(e, e.currentTarget)}
      >
        <button className="modal-close" onClick={onClose}>&times;</button>
        {title && <h2>{title}</h2>}
        {children}
      </div>
    </div>
  );
}
